var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomUserJoinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.5c0 1.664-1.36 3-3 3a2.99 2.99 0 01-3-3c0-1.64 1.336-3 3-3 1.64 0 3 1.36 3 3zM.5 11.82a4.171 4.171 0 014.172-4.195h2.133A4.191 4.191 0 0111 11.82c0 .375-.328.68-.703.68H1.18a.68.68 0 01-.68-.68zm14.648-7.172l-3 3c-.234.235-.585.235-.796 0l-1.5-1.5a.513.513 0 010-.773c.21-.234.562-.234.796 0l1.102 1.102 2.602-2.625c.21-.211.562-.211.773 0 .234.234.234.586 0 .796h.023z",
    fill: "#fff"
  })));
}
export default SvgRoomUserJoinIcon;